import { LOCATION_REQUIRED_FIELDS } from "../../components/Table/constants";

export const verifyTableRowsForUpdate = (
  setErrorMessage,
  setSuccessMessage,
  setBlockMessages,
  setUpdateErrors,
  updatedData
) => {
  setErrorMessage("");
  setSuccessMessage("");
  setBlockMessages([]);
  setUpdateErrors([]);
  const updateList = updatedData.filter((row) => row.updated);

  if (!updateList.length) {
    setErrorMessage("No changes to save");
    return false;
  }

  const hasInvalidRow = updateList.some((updateItem) => {
    const { lastVehicle, pulloutLocation } = updateItem;
    if (!lastVehicle && pulloutLocation) {
      setErrorMessage(
        "Bus and Location fields in the same row must be BOTH filled or BOTH empty"
      );
      return true;
    }
    if (lastVehicle && !pulloutLocation) {
      setErrorMessage(
        "Bus and Location fields in the same row must be BOTH filled or BOTH empty"
      );
      return true;
    }

    // Check location-specific required fields
    const requiredFields = LOCATION_REQUIRED_FIELDS[pulloutLocation];
    if (requiredFields) {
      const missingField = requiredFields.find(
        ({ field }) => !updateItem[field]
      );
      if (missingField) {
        setErrorMessage(
          `"${missingField.label}" is required when Location is "${pulloutLocation}" (Box ${updateItem.boxNumber})`
        );
        return true;
      }
    }

    return false;
  });

  return !hasInvalidRow;
};
